import axios from './http';
import { CancelTokenSource } from 'axios';
import { TenantConfigUpsertDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/tenant-config`;

export const getUpsertTenantConfig = (source: CancelTokenSource) : Promise<TenantConfigUpsertDto>=> {

  return axios
      .get(`${apiUri}/upsert-tenant`, {cancelToken: source.token})
      .then(response => response.data);
};

export const editUpsertTenant = (
    tenantConfigDto: Partial<TenantConfigUpsertDto>,
    source: CancelTokenSource)
    : Promise<TenantConfigUpsertDto> => {

  return axios
      .put(`${apiUri}/upsert-tenant`, tenantConfigDto, {cancelToken: source.token})
      .then(response => response.data);
};
